
export class SupplierRequestVO {
  // 取引先コード
  public supplier: string = <string>'';
  // 項番2231 START 障害管理NO.U01449対応
  public flag: string = <string>'';
  // 項番2231 END 障害管理NO.U01449対応

  /**
   * フォーカスアウト時に発行されたイベントオブジェクト
   */
  public focusEvent: FocusEvent = null;
}
